<fieldset class="uk-fieldset uk-form-horizontal">
  <form
    name="coForm"
    class="co-form-address"
    (ngSubmit)="onSubmit()"
    [formGroup]="addressForm"
    novalidate
    [ngClass]="{
      'co-form-address--skl': env === 'skl' && showCartPage,
      'co-form-address--nkl': env === 'nkl' && showCartPage
    }"
  >
    <h2 class="uk-h3" id="email-data-headline">E-Mail Adresse</h2>
    <div class="co-form-address__email" id="email-data">
      <div class="co-form-group">
        <div class="uk-margin-small">
          <div class="uk-form-label">
            <label for="email" class="middle">
              E-Mail-Adresse
              <i
                *ngIf="showCartPage"
                class="co-icon"
                aria-label="Wir senden Ihnen regelmäßig Informationen über eigene ähnliche Glöckle-Angebote per E-Mail/Newsletter. Der Nutzung Ihrer E-Mail-Adresse für Werbezwecke kann jederzeit durch formlose E-Mail an widerspruch@gloeckle.de widersprochen werden, ohne dass hierfür andere als die Übermittlungskosten nach den Basistarifen entstehen."
              >
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <path
                    d="M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z"
                  ></path>
                  <circle
                    fill="none"
                    stroke="#000"
                    stroke-width="1.1"
                    cx="10"
                    cy="10"
                    r="9"
                  ></circle>
                </svg>
              </i>
            </label>
          </div>
          <div class="uk-form-controls">
            <input
              type="email"
              id="email"
              class="uk-input"
              formControlName="email"
              (blur)="
                validateEmail($event.target.value);
                checkExistingEmail($event.target.value)
              "
            />
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('email').hasError('required') &&
                addressForm.get('email').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie Ihre E-Mail-Adresse an.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('email').hasError('pattern') &&
                addressForm.get('email').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie eine korrekte E-Mail an.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('email').hasError('notReal') &&
                addressForm.get('email').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Diese E-Mail-Adresse existiert nicht.
            </div>
          </div>
        </div>
      </div>
      <div class="email-alert" *ngIf="showEmailAlert">
        <i class="email-icon"
          ><svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              fill="none"
              stroke="#fff"
              stroke-width="1.1"
              cx="9.9"
              cy="6.4"
              r="4.4"
            ></circle>
            <path
              fill="none"
              stroke="#fff"
              stroke-width="1.1"
              d="M1.5,19 C2.3,14.5 5.8,11.2 10,11.2 C14.2,11.2 17.7,14.6 18.5,19.2"
            ></path></svg
        ></i>
        <div class="email-alert__text" *ngIf="!emailExists">
          Sie haben noch kein Kundenkonto?<br />
          Mit Ihrer Online-Losbestellung registrieren Sie sich automatisch.
        </div>
        <div class="email-alert__text" *ngIf="emailExists">
          Für diese E-Mail-Adresse existiert bereits ein Kundenkonto!
          <a [href]="loginUrl">Hier können Sie sich einloggen</a>
        </div>
      </div>
    </div>
    <h2 class="uk-h3" id="personal-data-headline">Persönliche Daten</h2>
    <div id="personal-data" class="co-form-address__personal">
      <div class="co-form-group">
        <div class="uk-margin-small">
          <div class="uk-form-label">
            <label for="" class="middle">Anrede</label>
          </div>
          <div class="uk-margin uk-grid-small uk-child-width-auto uk-grid">
            <label
              ><input
                type="radio"
                name="salutation"
                id="salutationMale"
                value="Herr"
                class="uk-radio"
                formControlName="salutation"
                checked
              />
              Herr</label
            >
            <label>
              <input
                type="radio"
                name="salutation"
                id="salutationFemale"
                formControlName="salutation"
                class="uk-radio"
                value="Frau"
              />
              Frau</label
            >
            <label
              ><input
                type="radio"
                name="salutation"
                id="salutationNone"
                formControlName="salutation"
                class="uk-radio"
                value="Divers"
              />
              keine Angabe</label
            >
          </div>
        </div>
      </div>
      <div class="co-form-group">
        <div class="uk-margin-small">
          <div class="uk-form-label">
            <label for="firstName" class="middle">Vorname</label>
          </div>
          <div class="uk-form-controls">
            <input
              type="text"
              class="uk-input"
              id="firstName"
              (blur)="capitalizeFirstLetter($event.target.value, 'firstName')"
              formControlName="firstName"
            />
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('firstName').hasError('required') &&
                addressForm.get('firstName').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie Ihren Vornamen an.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('firstName').hasError('pattern') &&
                addressForm.get('firstName').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie einen gültigen Vornamen ein.
            </div>
          </div>
        </div>
      </div>
      <div class="co-form-group">
        <div class="uk-margin-small">
          <div class="uk-form-label">
            <label for="lastName" class="middle">Nachname</label>
          </div>
          <div class="uk-form-controls">
            <input
              type="text"
              class="uk-input"
              id="lastName"
              (blur)="capitalizeFirstLetter($event.target.value, 'lastName')"
              formControlName="lastName"
            />
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('lastName').hasError('required') &&
                addressForm.get('lastName').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie Ihren Nachnamen an.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('lastName').hasError('pattern') &&
                addressForm.get('lastName').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie einen gültigen Nachnamen ein.
            </div>
          </div>
        </div>
      </div>
      <div class="co-form-group">
        <div class="uk-margin-small">
          <div class="uk-form-label">
            <label for="zip" class="middle">Postleitzahl</label>
          </div>
          <div class="uk-form-controls">
            <div class="clearfix">
              <input
                type="text"
                name="zip"
                id="zip"
                class="co-form-input--zip uk-input"
                formControlName="zip"
                (keyup)="validateZip($event.target.value)"
                (blur)="validateZip($event.target.value)"
              />
              <span
                *ngIf="checkIfSingleCity(city)"
                class="co-form-text--city"
                >{{ city }}</span
              >
              <div class="co-form-select" *ngIf="cities">
                <i class="co-form-select__icon">
                  <svg viewBox="0 0 24 24">
                    <path
                      d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                    />
                  </svg>
                </i>
                <select
                  name=""
                  id="citySelect"
                  class="co-form-select__item uk-select"
                  formControlName="cities"
                  (change)="onCitySelect($event.target.value)"
                  *ngIf="cities"
                >
                  <option *ngFor="let city of cities">
                    {{ city }}
                  </option>
                </select>
              </div>
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('zip').hasError('required') &&
                addressForm.get('zip').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie eine Postleitzahl an.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('zip').hasError('noZip') &&
                addressForm.get('zip').touched
              "
            >
              Diese Postleitzahl ist nicht korrekt.
            </div>
          </div>
        </div>
      </div>
      <div class="co-form-group">
        <div class="uk-margin-small">
          <div class="uk-form-label">
            <label for="street" class="middle">Straße / Hausnummer</label>
          </div>
          <div class="uk-form-controls uk-flex uk-flex-between">
            <div class="co-form-input--street">
              <input
                type="text"
                auto-complete
                no-match-found-text="Diese Straße wurde nicht gefunden"
                [source]="streets || []"
                class="uk-input"
                id="street"
                (valueChanged)="onStreetSelect($event, focusable)"
                formControlName="street"
                autocomplete="new-password"
              />
              <div
                class="co-form-error"
                *ngIf="
                  addressForm.get('street').hasError('required') &&
                  addressForm.get('street').touched
                "
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >Bitte geben Sie Ihre Straße an.
              </div>
              <div
                class="co-form-error"
                *ngIf="
                  addressForm.get('street').hasError('pattern') &&
                  addressForm.get('street').touched
                "
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >Bitte geben Sie eine gültige Strasse ein.
              </div>
            </div>
            <div class="co-form-input--streetNr">
              <input
                type="text"
                autocomplete="new-password"
                class="uk-input"
                #focusable
                formControlName="streetNumber"
                id="streetNumber"
                (blur)="trimStreetNumber($event.target.value)"
              />
              <div
                class="co-form-error"
                *ngIf="
                  addressForm.get('streetNumber').hasError('required') &&
                  addressForm.get('streetNumber').touched
                "
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >Bitte geben Sie Ihre Hausnummer an.
              </div>
              <div
                class="co-form-error"
                *ngIf="
                  addressForm.get('streetNumber').hasError('maxlength') &&
                  addressForm.get('streetNumber').touched
                "
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >Die Hausnummer darf maximal 10 Zeichen haben.
              </div>
              <div
                class="co-form-error"
                *ngIf="
                  addressForm.get('streetNumber').hasError('pattern') &&
                  addressForm.get('streetNumber').touched
                "
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >Bitte geben Sie eine gültige Hausnummer ein.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="co-form-group">
        <div class="uk-margin-small">
          <div class="uk-form-label">
            <label for="country" class="middle">
              Land
              <i
                *ngIf="showCartPage"
                class="co-icon"
                aria-label="Eine Teilnahme ist nur mit Wohnsitz in Deutschland möglich."
              >
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <path
                    d="M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z"
                  ></path>
                  <circle
                    fill="none"
                    stroke="#000"
                    stroke-width="1.1"
                    cx="10"
                    cy="10"
                    r="9"
                  ></circle>
                </svg>
              </i>
            </label>
          </div>
          <div class="uk-form-controls">
            <input
              type="text"
              id="country"
              class="uk-input"
              value="Deutschland"
              formControlName="country"
              readonly
              tabindex="-1"
            />
            <span
              *ngIf="!showCartPage"
              title="Eine Teilnahme ist nur mit Wohnsitz in Deutschland möglich."
              uk-tooltip="pos: top"
            >
              <span
                class="uk-margin-small-left uk-text-muted"
                uk-icon="info"
              ></span>
            </span>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('country').hasError('required') &&
                addressForm.get('country').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie Ihre Land an.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('country').hasError('minlength') &&
                addressForm.get('country').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie mindestens 2 Zeichen an.
            </div>
          </div>
        </div>
      </div>
      <div class="co-form-group">
        <div class="uk-margin-small">
          <div class="uk-form-label">
            <label for="phone" class="middle">
              Telefonnummer
              <span class="form-label-optional">(Optional)</span>&nbsp;
              <i
                *ngIf="showCartPage"
                class="co-icon"
                aria-label="Über hohe Gewinne informieren wir Sie gern telefonisch."
              >
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <path
                    d="M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z"
                  ></path>
                  <circle
                    fill="none"
                    stroke="#000"
                    stroke-width="1.1"
                    cx="10"
                    cy="10"
                    r="9"
                  ></circle>
                </svg>
              </i>
            </label>
          </div>
          <div class="uk-form-controls">
            <input
              type="tel"
              id="phone"
              name="phone"
              class="uk-input"
              formControlName="phoneNumber"
              (blur)="validatePhone($event.target.value)"
              placeholder=""
            />
            <span
              *ngIf="!showCartPage"
              title="Über hohe Gewinne informieren wir Sie gern telefonisch."
              uk-tooltip="pos: top"
            >
              <span
                class="uk-margin-small-left uk-text-muted"
                uk-icon="info"
              ></span>
            </span>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('phoneNumber').hasError('required') &&
                addressForm.get('phoneNumber').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie Ihre Telefonnummer an.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('phoneNumber').hasError('minlength') &&
                addressForm.get('phoneNumber').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie mindestens 2 Zeichen an.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('phoneNumber').hasError('maxlength') &&
                addressForm.get('phoneNumber').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie maximal 50 Zeichen an.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('phoneNumber').hasError('notReal') &&
                addressForm.get('phoneNumber').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Diese Telefonnummer existiert nicht.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('phoneNumber').hasError('pattern') &&
                addressForm.get('phoneNumber').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie eine gültige Telefonnummer ein.
            </div>
          </div>
        </div>
      </div>
      <div class="co-form-group">
        <div class="uk-margin-small">
          <div class="uk-form-label">
            <label for="birthday" class="middle">
              Geburtsdatum
              <i
                *ngIf="showCartPage"
                class="co-icon"
                aria-label="Spielteilnahme ab 18. Wir sind gesetzlich verpflichtet, Ihr Alter und Ihre Identität zu prüfen. Weitere Infos unter Datenschutz."
              >
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <path
                    d="M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z"
                  ></path>
                  <circle
                    fill="none"
                    stroke="#000"
                    stroke-width="1.1"
                    cx="10"
                    cy="10"
                    r="9"
                  ></circle>
                </svg>
              </i>
            </label>
          </div>
          <div class="uk-form-controls">
            <input
              type="text"
              id="birthday"
              class="uk-input"
              [textMask]="{
                mask: dateMask,
                pipe: autoCorrectedDatePipe,
                keepCharPositions: true,
                guide: true
              }"
              placeholder="TT.MM.JJJJ"
              formControlName="birthday"
              (blur)="validateAge($event.target.value)"
            />
            <span
              *ngIf="!showCartPage"
              title="Spielteilnahme ab 18. Wir sind gesetzlich verpflichtet, Ihr Alter und Ihre Identität zu prüfen. Weitere Infos unter Datenschutz."
              uk-tooltip="pos: top"
            >
              <span
                class="uk-margin-small-left uk-text-muted"
                uk-icon="info"
              ></span>
            </span>

            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('birthday').hasError('required') &&
                addressForm.get('birthday').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie Ihren Geburtstag an.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('birthday').hasError('minlength') &&
                addressForm.get('birthday').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie mindestens 2 Zeichen an.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('birthday').hasError('tooYoung') &&
                addressForm.get('birthday').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Sie müssen mindestens 18 Jahre alt sein.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('birthday').hasError('tooOld') &&
                addressForm.get('birthday').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte prüfen Sie Ihr Geburtsdatum.
            </div>
          </div>
        </div>
      </div>
      <div class="co-form-group">
        <div class="uk-margin-small">
          <div class="uk-form-label">
            <label for="birthName" class="middle">
              Geburtsname

              <i
                *ngIf="showCartPage"
                class="co-icon"
                aria-label="Der Geburtsname ist der durch die Abstammung erworbene ursprüngliche Nachname. Wir sind nach dem GlüStV 2021 gesetzlich verpflichtet, bei der Registrierung Ihren Geburtsnamen abzufragen. Bitte ändern, falls abweichend vom Nachnamen."
              >
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <path
                    d="M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z"
                  ></path>
                  <circle
                    fill="none"
                    stroke="#000"
                    stroke-width="1.1"
                    cx="10"
                    cy="10"
                    r="9"
                  ></circle>
                </svg>
              </i>
            </label>
          </div>
          <div class="uk-form-controls">
            <input
              type="text"
              class="uk-input"
              id="birthName"
              (blur)="capitalizeFirstLetter($event.target.value, 'birthName')"
              formControlName="birthName"
            />
            <span
              *ngIf="!showCartPage"
              title="Der Geburtsname ist der durch die Abstammung erworbene ursprüngliche Nachname. Wir sind nach dem GlüStV 2021 gesetzlich verpflichtet, bei der Registrierung Ihren Geburtsnamen abzufragen. Bitte ändern, falls abweichend vom Nachnamen."
              uk-tooltip="pos: top"
            >
              <span
                class="uk-margin-small-left uk-text-muted"
                uk-icon="info"
              ></span>
            </span>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('birthName').hasError('required') &&
                addressForm.get('birthName').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie Ihren Geburtsnamen an.
            </div>
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('birthName').hasError('pattern') &&
                addressForm.get('birthName').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie einen gültigen Namen ein.
            </div>
          </div>
        </div>
      </div>
      <div class="co-form-group">
        <div class="uk-margin-small">
          <div class="uk-form-label">
            <label for="birthplace" class="middle">Geburtsort</label>
          </div>
          <div class="uk-form-controls">
            <input
              type="text"
              class="uk-input"
              id="birthplace"
              (blur)="capitalizeFirstLetter($event.target.value, 'birthplace')"
              formControlName="birthplace"
            />
            <div
              class="co-form-error"
              *ngIf="
                addressForm.get('birthplace').hasError('required') &&
                addressForm.get('birthplace').touched
              "
            >
              <span
                class="uk-margin-small-right uk-text-danger"
                uk-icon="info"
              ></span
              >Bitte geben Sie Ihren Geburtsort an
            </div>
          </div>
        </div>
      </div>
    </div>

    <h2 class="uk-h3" id="payment-data-headline">Zahlungsart</h2>

    <div id="payment-selection" *ngIf="!isLoggedIn">
      <div>
        <div class="uk-flex uk-flex-between uk-flex-middle">
          <label class="payment-type uk-h4 uk-margin-remove">
            <input
              type="radio"
              name="paymentType"
              id="paymentTypePaypal"
              value="paypal"
              class="uk-radio"
              formControlName="paymentType" />
            PayPal
            <span
              class="uk-margin-small-left"
              uk-icon="info"
              uk-tooltip="Haben Sie in Ihrem Paypal-Konto als hinterlegte Zahlungsart „Kreditkarte“ ausgewählt, kann Ihre Bank zusätzliche Gebühren für die Kreditkartenzahlung berechnen. Darauf haben wir leider keinen Einfluss."
            ></span
          ></label>
          <div class="paypal-logo">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1280"
              height="339.345"
              viewBox="0 0 338.667 89.785"
            >
              <path
                fill="#003087"
                d="M108.294 17.955c-.697 0-1.289.506-1.398 1.195l-8.068 51.165a1.31 1.31 0 0 0 1.294 1.513h9.568c.696 0 1.289-.507 1.398-1.195l2.37-15.025a1.415 1.415 0 0 1 1.398-1.195h8.699c10.164 0 18.792-7.416 20.368-17.465 1.589-10.134-6.328-18.971-17.549-18.993zm9.301 11.422h6.96c5.73 0 7.596 3.381 7.006 7.12-.59 3.747-3.488 6.507-9.031 6.507h-7.084zm45.788 3.478c-2.416.009-5.196.504-8.317 1.804-7.159 2.984-10.597 9.151-12.057 13.647 0 0-4.647 13.717 5.852 21.253 0 0 9.737 7.255 20.698-.447l-.189 1.203a1.31 1.31 0 0 0 1.292 1.513h9.083c.697 0 1.289-.507 1.398-1.195l5.525-35.038a1.31 1.31 0 0 0-1.292-1.515h-9.083c-.697 0-1.29.507-1.398 1.195l-.297 1.886s-3.967-4.333-11.216-4.306zm.297 11.067c1.043 0 1.997.144 2.853.419 3.919 1.258 6.141 5.023 5.498 9.104-.793 5.025-4.914 8.725-10.199 8.725-1.042 0-1.996-.143-2.853-.418-3.918-1.258-6.154-5.023-5.511-9.104.793-5.025 4.927-8.727 10.212-8.727z"
              />
              <path
                fill="#0070e0"
                d="M239.094 17.955c-.697 0-1.289.506-1.398 1.195l-8.068 51.165a1.31 1.31 0 0 0 1.294 1.513h9.568c.696 0 1.289-.507 1.398-1.195l2.37-15.025a1.415 1.415 0 0 1 1.398-1.195h8.699c10.164 0 18.791-7.416 20.366-17.465 1.59-10.134-6.326-18.971-17.547-18.993zm9.301 11.422h6.96c5.73 0 7.596 3.381 7.006 7.12-.59 3.747-3.487 6.507-9.031 6.507h-7.084zm45.787 3.478c-2.416.009-5.196.504-8.317 1.804-7.159 2.984-10.597 9.151-12.057 13.647 0 0-4.645 13.717 5.854 21.253 0 0 9.735 7.255 20.697-.447l-.189 1.203a1.31 1.31 0 0 0 1.294 1.513h9.082c.697 0 1.289-.507 1.398-1.195l5.527-35.038a1.31 1.31 0 0 0-1.294-1.515h-9.083c-.697 0-1.29.507-1.398 1.195l-.297 1.886s-3.967-4.333-11.216-4.306zm.297 11.067c1.043 0 1.997.144 2.853.419 3.919 1.258 6.141 5.023 5.498 9.104-.793 5.025-4.914 8.725-10.199 8.725-1.042 0-1.996-.143-2.853-.418-3.918-1.258-6.154-5.023-5.511-9.104.793-5.025 4.927-8.727 10.212-8.727z"
              />
              <path
                fill="#003087"
                d="M190.978 34.08c-.72 0-1.232.703-1.012 1.388l9.958 30.901-9.004 14.562c-.437.707.071 1.62.902 1.62h10.642a1.77 1.77 0 0 0 1.513-.854l27.811-46.007a1.063 1.063 0 0 0-.909-1.611h-10.641a1.77 1.77 0 0 0-1.522.869L207.769 53.43l-5.557-18.345a1.42 1.42 0 0 0-1.355-1.006z"
              />
              <path
                fill="#0070e0"
                d="M327.791 17.955c-.696 0-1.289.507-1.398 1.195l-8.07 51.163a1.31 1.31 0 0 0 1.294 1.515h9.568c.696 0 1.289-.507 1.398-1.195l8.068-51.165a1.31 1.31 0 0 0-1.292-1.513z"
              />
              <path
                fill="#001c64"
                d="M28.528 17.955a2.59 2.59 0 0 0-2.556 2.185l-4.247 26.936a2.59 2.59 0 0 1 2.556-2.185h12.445c12.525 0 23.153-9.137 25.095-21.519a21 21 0 0 0 .245-2.793c-3.183-1.669-6.922-2.624-11.019-2.624z"
              />
              <path
                fill="#0070e0"
                d="M62.066 20.58a21 21 0 0 1-.245 2.793C59.879 35.755 49.25 44.892 36.726 44.892H24.281a2.59 2.59 0 0 0-2.556 2.185L17.82 71.829l-2.446 15.528a2.1 2.1 0 0 0 2.075 2.43h13.508a2.59 2.59 0 0 0 2.556-2.185l3.558-22.567a2.59 2.59 0 0 1 2.558-2.185h7.953c12.525 0 23.153-9.137 25.095-21.519 1.379-8.788-3.047-16.784-10.611-20.75z"
              />
              <path
                fill="#003087"
                d="M13.182 0a2.59 2.59 0 0 0-2.556 2.183L.026 69.399a2.103 2.103 0 0 0 2.077 2.43h15.719l3.903-24.752 4.247-26.936a2.59 2.59 0 0 1 2.556-2.185h22.519c4.098 0 7.836.956 11.019 2.624C62.284 9.307 52.982 0 40.193 0z"
              />
            </svg>
          </div>
        </div>
        <div
          class="co-form-address__payment uk-margin"
          *ngIf="addressForm.get('paymentType').value === 'paypal'"
        >
          <p>
            Der PayPal-Kontoinhaber muss mit dem Spielteilnehmer übereinstimmen!
          </p>
          <p>
            Nachdem Sie Ihre Losbestellung getätigt haben, werden Sie direkt zu
            PayPal weitergeleitet.
          </p>

          <p>
            Hiermit ermächtige ich widerruflich die GLÖCKLE GmbH & Co. KG, ab
            jetzt monatlich mein PayPal Konto mit dem jeweils fälligen Betrag zu
            belasten. Durch Beendigung der Spielteilnahme erlischt automatisch
            die PayPal-Abbuchungsermächtigung.
          </p>
        </div>
      </div>
      <div class="uk-margin uk-flex uk-flex-between uk-flex-middle">
        <label class="payment-type uk-h4 uk-margin-remove">
          <input
            type="radio"
            name="paymentType"
            id="paymentTypeSepa"
            value="ibanWithSepa"
            class="uk-radio"
            formControlName="paymentType"
          />
          SEPA-Lastschrift</label
        >
        <div class="sepa-logo">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 100">
            <defs>
              <style>
                .cls-3 {
                  fill: #005ca9;
                }
              </style>
            </defs>
            <g id="Ebene_1">
              <path
                d="M192 25h-5.9c-1.1 0-2 .9-2 2v19.3c0 1.1.9 2 2 2h6.4c9.5 0 13.9-4.4 13.9-12.5s-5.1-10.9-14.4-10.9Z"
                style="fill: none"
              />
              <path
                d="m50.7 44.6-10-4.1c-7.2-2.8-12.2-4.4-12.2-9.1s3.8-6.5 9.7-6.5 9.6 1.7 14.5 4.9 2 .4 2.6-.4l7.6-9.5c.7-.9.6-2.1-.3-2.8-6.7-5.6-15.6-8.7-24.5-8.7C21.1 8.4 9 19.3 9 32.7s7.8 18.6 16.3 22l10.2 4.4c7 2.8 11.3 4.3 11.3 9s-3.3 7-10.6 7-13.2-2.3-18.7-6.4-2.1-.5-2.8.3L7 78.4c-.7.8-.6 2.1.3 2.8 8.2 7.1 18.3 10.4 28.5 10.4 19.4 0 30.6-11.7 30.6-25.2s-5.9-17.9-15.9-21.8ZM193.1 9.8h-26.2c-1.1 0-2 .9-2 2v76.3c0 1.1.9 2 2 2h15.2c1.1 0 2-.9 2-2V65.5c0-1.1.9-2 2-2h7.5c16.9 0 31.6-8.4 31.6-27.6s-14.4-26-32.1-26Zm-7 38.5c-1.1 0-2-.9-2-2V27c0-1.1.9-2 2-2h5.9c9.4 0 14.4 2.8 14.4 10.9s-4.4 12.5-13.9 12.5M267.5 9.8h-20c-.9 0-1.7.6-1.9 1.4l-23.8 76.3c-.4 1.3.6 2.6 1.9 2.6H239c.9 0 1.7-.6 1.9-1.5l3.9-15.5c.2-.9 1-1.5 1.9-1.5h20.7c.9 0 1.7.6 1.9 1.5l3.9 15.5c.2.9 1 1.5 1.9 1.5H291c1.4 0 2.3-1.3 1.9-2.6l-23.8-76.3c-.3-.8-1-1.4-1.9-1.4Zm-16 47c-1.3 0-2.3-1.2-1.9-2.5l1.1-4.4c1.5-5.5 3-11.7 4.5-17.8s3.4-2 3.9 0c1.5 5.8 3.4 13.4 4.6 17.8l1.1 4.4c.3 1.3-.6 2.5-1.9 2.5h-11.3Z"
                class="cls-3"
              />
              <path
                d="M149.5 69.3c-1.9 1.9-3.5 3.2-4.8 4.2h-.1c-2.5 1.9-3.8 2.4-3.8 2.4-4.3 2.4-9.2 3.6-14.3 3.6s-6.9-.6-10.2-1.8c-5.5-2-10.3-5.6-13.7-10.3s0-1.5.8-1.5h32.7c.8 0 1.5-.5 1.9-1.2l3.6-8.5c.5-1.3-.4-2.8-1.9-2.8H98.9c-1.1 0-1.9-.8-2-1.9s0-1.1 0-1.7v-1.7c0-1.1.9-1.9 2-1.9h42.7c.8 0 1.5-.5 1.9-1.2l2.3-5.5 1.2-3.1c.5-1.3-.4-2.7-1.9-2.7h-41.7c-.8 0-1.2-.9-.8-1.5 3.5-4.7 8.2-8.3 13.7-10.3 3.2-1.2 6.6-1.8 10.1-1.8 7.3 0 14.4 2.7 19.9 7.7l1 .9c1 .9 2.7.6 3.2-.7l3.5-8.4c.3-.8 0-1.8-.6-2.3l-.6-.5c-7.5-6-16.9-9.2-26.4-9.2s-21 4-28.8 11.4c-4.1 3.8-7.4 8.5-9.7 13.5s-1 1.2-1.8 1.2h-6.7c-.8 0-1.5.5-1.9 1.2l-3.6 8.5c-.5 1.3.4 2.8 1.9 2.8H83c.7 0 1.2.6 1.2 1.3v4.6c0 1.5-.5 1.3-1.2 1.3h-3.7c-.8 0-1.5.5-1.9 1.2l-3.6 8.5c-.5 1.3.4 2.8 1.9 2.8h10.2c.8 0 1.5.5 1.8 1.2 1.7 3.9 4 7.4 6.8 10.6 8 9.1 19.6 14.3 31.8 14.3s19.4-3.5 27-9.8l.4-.3c.5-.4.7-.9.7-1.5V68.8c0-1.8-2.2-2.7-3.4-1.4s-1.1 1.1-1.7 1.7Z"
                style="fill: #009fe3"
              />
            </g>
          </svg>
        </div>
      </div>
      <div *ngIf="addressForm.get('paymentType').value === 'ibanWithSepa'">
        <p *ngIf="hasSepa">
          Legen Sie Ihr Konto für Gewinnauszahlung und SEPA Lastschrift fest.
        </p>
        <p *ngIf="!hasSepa">Legen Sie Ihr Konto für Gewinnauszahlung fest.</p>
        <div
          id="payment-data"
          class="co-form-address__payment"
          *ngIf="!invoiceOnly"
        >
          <div class="co-form-group uk-margin">
            <label class="uk-form-label" for=""
              >Kontoinhaber
              <span
                class="uk-margin-small-left"
                uk-icon="info"
                uk-tooltip="Der Kontoinhaber muss mit dem Spielteilnehmer übereinstimmen."
              ></span>
            </label>
            <div class="uk-form-controls empty">
              <span
                class="uk-text-muted"
                *ngIf="
                  addressForm.value.firstName || addressForm.value.lastName
                "
                >{{ addressForm.value.firstName }}
                {{ addressForm.value.lastName }}</span
              >
              <span
                class="uk-text-muted"
                *ngIf="
                  !addressForm.value.firstName && !addressForm.value.lastName
                "
                >Wird automatisch übernommen</span
              >
            </div>
          </div>

          <div class="co-form-group uk-margin">
            <label class="uk-form-label" for="iban">
              <span *ngIf="!payment">IBAN oder KTO</span>
              <span *ngIf="payment === 'iban'">IBAN</span>
              <span *ngIf="payment === 'account'">KTO</span>&nbsp;
              <span
                class="uk-margin-small-left"
                uk-icon="info"
                uk-tooltip="Die IBAN wird zur Überweisung Ihrer Gewinne und für das SEPA-Lastschriftverfahren benötigt."
              ></span>
            </label>
            <div class="uk-form-controls">
              <input
                type="text"
                class="uk-input"
                [textMask]="{ mask: getIbanMask }"
                id="iban"
                formControlName="iban"
                (keyup)="
                  paymentType($event.target.value);
                  validateIban($event.target.value)
                "
              />

              <div
                class="co-form-error"
                *ngIf="
                  addressForm.get('iban').hasError('required') &&
                  addressForm.get('iban').touched
                "
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >Bitte geben Sie Ihre IBAN an.
              </div>
              <div
                class="co-form-error"
                *ngIf="
                  addressForm.get('iban').hasError('notReal') &&
                  addressForm.get('iban').touched &&
                  !addressForm.get('iban').hasError('required')
                "
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >Diese IBAN ist ungültig.
              </div>
              <div
                class="co-form-error"
                *ngIf="
                  addressForm.get('iban').hasError('ibanTooShort') &&
                  addressForm.get('iban').touched &&
                  !addressForm.get('iban').hasError('required')
                "
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >Diese IBAN ist ungültig.
              </div>
              <div
                class="co-form-error"
                *ngIf="
                  addressForm.get('iban').hasError('minLength') &&
                  addressForm.get('iban').touched &&
                  !addressForm.get('iban').hasError('required')
                "
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >Diese Kontonummer ist ungültig.
              </div>
              <div
                class="co-form-error"
                *ngIf="addressForm.get('iban').hasError('apiError')"
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >{{ apiErrorIban }}
              </div>
            </div>
          </div>

          <div class="co-form-group uk-margin" *ngIf="payment === 'account'">
            <label for="bankCode" class="uk-form-label">BLZ</label>
            <div class="uk-form-controls">
              <input
                type="text"
                class="uk-input"
                id="bankCode"
                formControlName="bankCode"
                (keyup)="validateBankAccount($event.target.value)"
              />
              <div
                class="co-form-error"
                *ngIf="
                  addressForm.get('bankCode').hasError('required') &&
                  addressForm.get('bankCode').touched
                "
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >Bitte geben Sie Ihre Bankleitzahl an.
              </div>
              <div
                class="co-form-error"
                *ngIf="
                  addressForm.get('bankCode').hasError('minlength') &&
                  addressForm.get('bankCode').touched
                "
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >Bitte geben Sie mindestens 2 Zeichen an.
              </div>
              <div
                class="co-form-error"
                *ngIf="
                  addressForm.get('bankCode').hasError('notReal') &&
                  addressForm.get('iban').touched
                "
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >Bankleitzahl und Kontonummer passen nicht zusammen.
              </div>
            </div>
          </div>
          <div class="co-form-group uk-margin">
            <label for="" class="uk-form-label"
              >BIC <span class="uk-margin-small-left"></span
            ></label>
            <div class="uk-form-controls empty">
              <span class="uk-text-muted" *ngIf="!bic"
                >Wird automatisch ermittelt.</span
              >
              <span *ngIf="bic">{{ bic }}</span>
            </div>
          </div>
          <div class="co-form-group uk-margin">
            <label for="" class="uk-form-label"
              >Name der Bank <span class="uk-margin-small-left"></span
            ></label>
            <div class="uk-form-controls empty">
              <span class="uk-text-muted" *ngIf="!bank"
                >Wird automatisch ermittelt.</span
              >
              <span *ngIf="bank">{{ bank }}</span>
            </div>
          </div>
          <div class="co-form-group uk-margin" *ngIf="!hasSepa">
            <label for="" class="uk-form-label">Zahlungsart</label>
            <div class="uk-form-controls empty">
              <span>Rechnung</span>
            </div>
          </div>
          <div class="co-form-group uk-margin" *ngIf="hasSepa">
            <input
              formControlName="sepaAccept"
              type="checkbox"
              id="sepa-accept"
              name="sepa-accept"
              class="uk-checkbox"
              required
            />
            <label for="sepa-accept">
              <strong>Ich möchte das SEPA Lastschriftmandat erteilen</strong>
              <div
                class="co-form-error"
                *ngIf="
                  addressForm.get('sepaAccept').hasError('required') &&
                  addressForm.get('sepaAccept').touched
                "
              >
                <span
                  class="uk-margin-small-right uk-text-danger"
                  uk-icon="info"
                ></span
                >Bitte erteilen Sie das SEPA Lastschriftmandat.
              </div>
              <p>
                Ich ermächtige die GLÖCKLE GmbH & Co. KG, Zahlungen von meinem
                Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein
                Kreditinstitut an, die von der GLÖCKLE GmbH & Co. KG auf mein
                Konto gezogene Lastschrift einzulösen. Hinweis: Ich kann
                innerhalb von acht Wochen, beginnend mit dem Belastungsdatum,
                die Erstattung des belasteten Betrags verlangen. Es gelten dabei
                die mit meinem Kreditinstitut vereinbarten Bedingungen. GLÖCKLE
                GmbH & Co. KG, Daimlerstr. 86, 70372 Stuttgart,
                Gläubiger-Ident.Nr.: DE42ZZZ00000062942, Mandatsreferenz wird
                separat mitgeteilt.
              </p>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div id="payment-saved-type" *ngIf="isLoggedIn">
      <div
        class="uk-flex uk-flex-between uk-flex-middle"
        *ngIf="addressForm.get('paymentType').value === 'paypal'"
      >
        <div class="payment-type uk-h4 uk-margin-remove">PayPal</div>
        <div class="paypal-logo">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1280"
            height="339.345"
            viewBox="0 0 338.667 89.785"
          >
            <path
              fill="#003087"
              d="M108.294 17.955c-.697 0-1.289.506-1.398 1.195l-8.068 51.165a1.31 1.31 0 0 0 1.294 1.513h9.568c.696 0 1.289-.507 1.398-1.195l2.37-15.025a1.415 1.415 0 0 1 1.398-1.195h8.699c10.164 0 18.792-7.416 20.368-17.465 1.589-10.134-6.328-18.971-17.549-18.993zm9.301 11.422h6.96c5.73 0 7.596 3.381 7.006 7.12-.59 3.747-3.488 6.507-9.031 6.507h-7.084zm45.788 3.478c-2.416.009-5.196.504-8.317 1.804-7.159 2.984-10.597 9.151-12.057 13.647 0 0-4.647 13.717 5.852 21.253 0 0 9.737 7.255 20.698-.447l-.189 1.203a1.31 1.31 0 0 0 1.292 1.513h9.083c.697 0 1.289-.507 1.398-1.195l5.525-35.038a1.31 1.31 0 0 0-1.292-1.515h-9.083c-.697 0-1.29.507-1.398 1.195l-.297 1.886s-3.967-4.333-11.216-4.306zm.297 11.067c1.043 0 1.997.144 2.853.419 3.919 1.258 6.141 5.023 5.498 9.104-.793 5.025-4.914 8.725-10.199 8.725-1.042 0-1.996-.143-2.853-.418-3.918-1.258-6.154-5.023-5.511-9.104.793-5.025 4.927-8.727 10.212-8.727z"
            />
            <path
              fill="#0070e0"
              d="M239.094 17.955c-.697 0-1.289.506-1.398 1.195l-8.068 51.165a1.31 1.31 0 0 0 1.294 1.513h9.568c.696 0 1.289-.507 1.398-1.195l2.37-15.025a1.415 1.415 0 0 1 1.398-1.195h8.699c10.164 0 18.791-7.416 20.366-17.465 1.59-10.134-6.326-18.971-17.547-18.993zm9.301 11.422h6.96c5.73 0 7.596 3.381 7.006 7.12-.59 3.747-3.487 6.507-9.031 6.507h-7.084zm45.787 3.478c-2.416.009-5.196.504-8.317 1.804-7.159 2.984-10.597 9.151-12.057 13.647 0 0-4.645 13.717 5.854 21.253 0 0 9.735 7.255 20.697-.447l-.189 1.203a1.31 1.31 0 0 0 1.294 1.513h9.082c.697 0 1.289-.507 1.398-1.195l5.527-35.038a1.31 1.31 0 0 0-1.294-1.515h-9.083c-.697 0-1.29.507-1.398 1.195l-.297 1.886s-3.967-4.333-11.216-4.306zm.297 11.067c1.043 0 1.997.144 2.853.419 3.919 1.258 6.141 5.023 5.498 9.104-.793 5.025-4.914 8.725-10.199 8.725-1.042 0-1.996-.143-2.853-.418-3.918-1.258-6.154-5.023-5.511-9.104.793-5.025 4.927-8.727 10.212-8.727z"
            />
            <path
              fill="#003087"
              d="M190.978 34.08c-.72 0-1.232.703-1.012 1.388l9.958 30.901-9.004 14.562c-.437.707.071 1.62.902 1.62h10.642a1.77 1.77 0 0 0 1.513-.854l27.811-46.007a1.063 1.063 0 0 0-.909-1.611h-10.641a1.77 1.77 0 0 0-1.522.869L207.769 53.43l-5.557-18.345a1.42 1.42 0 0 0-1.355-1.006z"
            />
            <path
              fill="#0070e0"
              d="M327.791 17.955c-.696 0-1.289.507-1.398 1.195l-8.07 51.163a1.31 1.31 0 0 0 1.294 1.515h9.568c.696 0 1.289-.507 1.398-1.195l8.068-51.165a1.31 1.31 0 0 0-1.292-1.513z"
            />
            <path
              fill="#001c64"
              d="M28.528 17.955a2.59 2.59 0 0 0-2.556 2.185l-4.247 26.936a2.59 2.59 0 0 1 2.556-2.185h12.445c12.525 0 23.153-9.137 25.095-21.519a21 21 0 0 0 .245-2.793c-3.183-1.669-6.922-2.624-11.019-2.624z"
            />
            <path
              fill="#0070e0"
              d="M62.066 20.58a21 21 0 0 1-.245 2.793C59.879 35.755 49.25 44.892 36.726 44.892H24.281a2.59 2.59 0 0 0-2.556 2.185L17.82 71.829l-2.446 15.528a2.1 2.1 0 0 0 2.075 2.43h13.508a2.59 2.59 0 0 0 2.556-2.185l3.558-22.567a2.59 2.59 0 0 1 2.558-2.185h7.953c12.525 0 23.153-9.137 25.095-21.519 1.379-8.788-3.047-16.784-10.611-20.75z"
            />
            <path
              fill="#003087"
              d="M13.182 0a2.59 2.59 0 0 0-2.556 2.183L.026 69.399a2.103 2.103 0 0 0 2.077 2.43h15.719l3.903-24.752 4.247-26.936a2.59 2.59 0 0 1 2.556-2.185h22.519c4.098 0 7.836.956 11.019 2.624C62.284 9.307 52.982 0 40.193 0z"
            />
          </svg>
        </div>
      </div>
      <div
        class="uk-margin uk-flex uk-flex-between uk-flex-middle"
        *ngIf="addressForm.get('paymentType').value === 'ibanWithSepa'"
      >
        <div class="payment-type uk-h4 uk-margin-remove">SEPA-Lastschrift</div>
        <div class="sepa-logo">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 100">
            <defs>
              <style>
                .cls-3 {
                  fill: #005ca9;
                }
              </style>
            </defs>
            <g id="Ebene_1">
              <path
                d="M192 25h-5.9c-1.1 0-2 .9-2 2v19.3c0 1.1.9 2 2 2h6.4c9.5 0 13.9-4.4 13.9-12.5s-5.1-10.9-14.4-10.9Z"
                style="fill: none"
              />
              <path
                d="m50.7 44.6-10-4.1c-7.2-2.8-12.2-4.4-12.2-9.1s3.8-6.5 9.7-6.5 9.6 1.7 14.5 4.9 2 .4 2.6-.4l7.6-9.5c.7-.9.6-2.1-.3-2.8-6.7-5.6-15.6-8.7-24.5-8.7C21.1 8.4 9 19.3 9 32.7s7.8 18.6 16.3 22l10.2 4.4c7 2.8 11.3 4.3 11.3 9s-3.3 7-10.6 7-13.2-2.3-18.7-6.4-2.1-.5-2.8.3L7 78.4c-.7.8-.6 2.1.3 2.8 8.2 7.1 18.3 10.4 28.5 10.4 19.4 0 30.6-11.7 30.6-25.2s-5.9-17.9-15.9-21.8ZM193.1 9.8h-26.2c-1.1 0-2 .9-2 2v76.3c0 1.1.9 2 2 2h15.2c1.1 0 2-.9 2-2V65.5c0-1.1.9-2 2-2h7.5c16.9 0 31.6-8.4 31.6-27.6s-14.4-26-32.1-26Zm-7 38.5c-1.1 0-2-.9-2-2V27c0-1.1.9-2 2-2h5.9c9.4 0 14.4 2.8 14.4 10.9s-4.4 12.5-13.9 12.5M267.5 9.8h-20c-.9 0-1.7.6-1.9 1.4l-23.8 76.3c-.4 1.3.6 2.6 1.9 2.6H239c.9 0 1.7-.6 1.9-1.5l3.9-15.5c.2-.9 1-1.5 1.9-1.5h20.7c.9 0 1.7.6 1.9 1.5l3.9 15.5c.2.9 1 1.5 1.9 1.5H291c1.4 0 2.3-1.3 1.9-2.6l-23.8-76.3c-.3-.8-1-1.4-1.9-1.4Zm-16 47c-1.3 0-2.3-1.2-1.9-2.5l1.1-4.4c1.5-5.5 3-11.7 4.5-17.8s3.4-2 3.9 0c1.5 5.8 3.4 13.4 4.6 17.8l1.1 4.4c.3 1.3-.6 2.5-1.9 2.5h-11.3Z"
                class="cls-3"
              />
              <path
                d="M149.5 69.3c-1.9 1.9-3.5 3.2-4.8 4.2h-.1c-2.5 1.9-3.8 2.4-3.8 2.4-4.3 2.4-9.2 3.6-14.3 3.6s-6.9-.6-10.2-1.8c-5.5-2-10.3-5.6-13.7-10.3s0-1.5.8-1.5h32.7c.8 0 1.5-.5 1.9-1.2l3.6-8.5c.5-1.3-.4-2.8-1.9-2.8H98.9c-1.1 0-1.9-.8-2-1.9s0-1.1 0-1.7v-1.7c0-1.1.9-1.9 2-1.9h42.7c.8 0 1.5-.5 1.9-1.2l2.3-5.5 1.2-3.1c.5-1.3-.4-2.7-1.9-2.7h-41.7c-.8 0-1.2-.9-.8-1.5 3.5-4.7 8.2-8.3 13.7-10.3 3.2-1.2 6.6-1.8 10.1-1.8 7.3 0 14.4 2.7 19.9 7.7l1 .9c1 .9 2.7.6 3.2-.7l3.5-8.4c.3-.8 0-1.8-.6-2.3l-.6-.5c-7.5-6-16.9-9.2-26.4-9.2s-21 4-28.8 11.4c-4.1 3.8-7.4 8.5-9.7 13.5s-1 1.2-1.8 1.2h-6.7c-.8 0-1.5.5-1.9 1.2l-3.6 8.5c-.5 1.3.4 2.8 1.9 2.8H83c.7 0 1.2.6 1.2 1.3v4.6c0 1.5-.5 1.3-1.2 1.3h-3.7c-.8 0-1.5.5-1.9 1.2l-3.6 8.5c-.5 1.3.4 2.8 1.9 2.8h10.2c.8 0 1.5.5 1.8 1.2 1.7 3.9 4 7.4 6.8 10.6 8 9.1 19.6 14.3 31.8 14.3s19.4-3.5 27-9.8l.4-.3c.5-.4.7-.9.7-1.5V68.8c0-1.8-2.2-2.7-3.4-1.4s-1.1 1.1-1.7 1.7Z"
                style="fill: #009fe3"
              />
            </g>
          </svg>
        </div>
      </div>
    </div>

    <div
      class="co-form-error"
      *ngIf="
        addressForm.get('paymentType').hasError('required') &&
        addressForm.get('paymentType').touched
      "
    >
      <span class="uk-margin-small-right uk-text-danger" uk-icon="info"></span
      >Bitte wählen Sie eine Zahlungsart.
    </div>

    <app-limit
      *ngIf="showLimit"
      [userLimit]="maxMonthlyCosts"
      (limitFormOutput)="onLimitFormChange($event)"
    ></app-limit>

    <div class="uk-alert-warning" uk-alert *ngIf="showLimitError">
      Der Bestellbetrag inkl. etwaiger Nachzahlung
      <span *ngIf="!showCartPage" [title]="limitText" uk-tooltip="pos: top">
        <span class="uk-margin-small-left uk-text-muted" uk-icon="info"></span>
      </span>
      darf maximal 150 € betragen. Bitte passen Sie Ihre Produktauswahl an, oder
      <a [href]="loginUrl">loggen Sie sich in das Kundenkonto ein.</a>
    </div>

    <div
      class="co-form-warning uk-alert-warning"
      uk-alert
      *ngIf="showSubmitError"
    >
      Bitte füllen Sie alle erforderlichen Felder aus, um die Bestellung
      fortsetzen zu können.
    </div>

    <footer class="co-content__footer">
      <div class="co-content__footer-info">
        <p *ngIf="showCartPage && !hideCouponText">
          Gutscheine können im letzten Bestellschritt “Bestellung überprüfen“
          eingelöst werden.
        </p>
        <p *ngIf="showCartPage && !isLoggedIn">
          Registrierung abschließen und GLÖCKLE-Kundenkonto anlegen.
        </p>
      </div>
      <div class="uk-text-center">
        <button class="uk-button uk-button-primary" id="ctaWeiter">
          Weiter
        </button>
      </div>
    </footer>
  </form>
</fieldset>
